<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" [routerLink]="getEditRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.effects.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div style="margin-bottom: 10px" *ngFor="let item of effects">
      <div class="ir-row" *ngIf="item.Realibility !== null && item.Realibility >= 0">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.effects.reliability' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Realibility }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.Perfomance !== null && item.Perfomance >= 0">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.effects.performance' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Perfomance }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.AccuracyAndQuality !== null && item.AccuracyAndQuality >= 0">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.effects.accuracyAndQuality' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.AccuracyAndQuality }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.Safety !== null && item.Safety >= 0">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.effects.safety' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Safety }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="item.Actions">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span><strong>{{ 'plugins.effects.actions' | translate }}</strong></span>
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ item.Actions }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
